import React, { Component } from 'react';
import styled from 'styled-components';
import loadImage from 'blueimp-load-image';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Webcam from '../../lib/react-webcam';
//import RevieveActions from '../../store/RevieveActions';
import Processing from './Processing';
import media from './MediaQueries';
import { translate } from 'react-polyglot';
import { getParameterByName } from '../../shared/urlFunctions';
import captureBg from '../../images/instore/capture-bg.png';

const StyledSelfieWrapper = styled.div`
  width: 100%;
  height: 100%;
  color: white;
  div.guide,
  h4.hint,
  button.cancel {
    position: absolute;
    right: 0;
    left: 0;
    margin: auto;
  }
  div.guide {
    top: 150px;
    width: 65%;
    height: 60%;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    border-radius: 30px;

    ${media.phone`
      border: none;
      background-image: url(${captureBg});
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      top: 100px;
      width: 90%;
      height: 60%;
    `}
  }
  h4.hint {
    font-size: 18px;
    font-weight: 300;
    bottom: 60px;
    text-align: center;
    max-width: 230px;
    line-height: 1.4;
    ${media.phone`
      font-size: 11px;
    `}
  }

  div.warning {
    position: absolute;
    width: 100%;
    bottom: 60px;
    font-size: 18px;
    text-align: center;
    line-height: 1.4;
    font-weight: 300;
    ul {
      padding: 0 30px;
    }
    ul,
    li {
      list-style: none;
    }
    ul li {
      margin-bottom: 10px;
    }
    &:before {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .action {
      button {
        cursor: pointer;
        width: auto;
        height: 60px;
        background: none;
        color: white;
        outline: none;
        border: none;
        font-size: 16px;
        font-weight: 400;
        text-decoration: underline;
        margin: 0 20px;
      }
    }
  }

  button.cancel {
    cursor: pointer;
    bottom: 10px;
    background: none;
    outline: none;
    color: inherit;
    border: none;
    font-size: 16px;
    text-decoration: underline;
    font-weight: 500;
    width: 140px;
    height: 60px;
  }

  &:before {
    z-index: -1;
    overflow: hidden;
    position: absolute;
    top: 0;
    content: '';
    width: 100%;
    height: 100%;
    background: url(${props => props.img});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    transition: background-size 0.25s ease-out, filter 0.25s ease-out;
  }
`;

const StyledPulse = styled.div`
  position: absolute;
  width: 50px;
  height: 50px;
  border: 2px solid white;
  border-radius: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: -60px;
  box-shadow: rgba(255, 255, 255, 0.4);
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 white;
    }
    70% {
      box-shadow: 0 0 0 80px white;
    }
    100% {
      box-shadow: 0 0 0 0 white;
    }
  }
  @keyframes op {
    0% {
      opacity: 0.4;
    }
    70% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  animation: pulse 2s infinite, op 2s infinite;
`;

const StyledHeading = styled.h1`
  font-size: 24px;
  font-weight: 300;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 80px;
  text-align: center;
  z-index: 1;

  ${media.phone`
    top: 40px;
  `}
`;

const StyledInstructions = styled.div`
  font-size: 18px;
  font-weight: 300;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 120px;
  text-align: center;
  z-index: 1;
  list-style: none;

  ${media.phone`
    top: 80px;
  `}
  max-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledInstruction = styled.div`
  margin: 0 2vw;
`;

const StyledWebcam = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: -1;
  display: flex;
  justify-content: center;
  video {
    width: ${props => {
      if (props.userAgent && (props.userAgent.indexOf('MSIE ') >= 0 || props.userAgent.indexOf('Edge/') >= 0)) {
        return 'auto';
      } else {
        return '100%';
      }
    }};
    height: 100%;
    transition: all 1s ease-in;
    object-fit: cover;
    z-index: -1;
  }
  video.revieve-camera-loading {
    filter: blur(40px);
    opacity: 0.01;
  }
  video.revieve-camera-ready {
    filter: blur(0px);
    opacity: 1;
  }
  video.revieve-camera-error {
    filter: blur(0px);
    background-color: red;
    opacity: 1;
  }
`;

const StyledTips = styled.div`
  font-size: 12px;
  width: 60%;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 8px;
  position: absolute;
  left: 20%;
  bottom: 120px;
  ${media.phone`
    width: 80%;
    left: 10%;
    bottom: 85px;
    padding: 10px;
  `}

  h1 {
    font-size: 14px;
    margin-bottom: 8px;
  }

  li {
    list-style-type: none;
  }

  .closeTips {
    float: right;
    cursor: pointer;
    font-weight: bolder;
  }
`;

class Selfie extends Component {
  constructor(props) {
    super(props);
    this.state = this.initState(props);
  }

  initState(props) {
    return {
      cameraOpen: true,
      image: null,
      cameraClass: 'revieve-camera-loading',
      cameraError: false,
      cvResults: null,
      showTips: props.options && props.options.showTips,
    };
  }

  componentDidMount() {
    //we need to check it there is some image loaded in the SDK. If yes, we need to trigger the retake callback
    const { sdk, triggerCallback } = this.props;
    if (sdk && sdk.CV && sdk.CV.getImage()) triggerCallback({ callback: 'retakeSelfie' });
  }

  reset = () => {
    const { triggerCallback } = this.props;
    triggerCallback({ callback: 'retakeSelfie' });
    this.setState(this.initState(this.props));
  };

  getSkinToneInt() {
    let skintone = 1;
    let skintones = ['light_tone', 'fair_tone', 'medium_tone', 'olive_tone', 'brown_tone', 'dark_brown_tone'];
    if (this.props.filters.requiredTags && typeof this.props.filters.requiredTags === 'object') {
      for (let rt of Object.keys(this.props.filters.requiredTags)) {
        let i = skintones.indexOf(rt);
        if (i > -1) {
          skintone = i + 1;
        }
      }
    }
    return skintone;
  }

  capture = () => {
    const { isBackground } = this.props;
    if (isBackground) {
      return;
    }
    //RevieveActions.removeImageData();
    // capture
    var im = this.webcam.getScreenshot();
    if (!im) {
      return;
    }
    var image_blob = (function() {
      var binary = atob(im.split(',')[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
    })();

    this.props.analyzeImage(im, this.getSkinToneInt());
    this.setState({ image: im, imageBlob: image_blob, cameraOpen: false });
  };

  handleImageChange = e => {
    e.preventDefault();
    let file = e.target.files[0];
    loadImage(
      file,
      canvas => {
        var base64data = canvas.toDataURL('image/jpeg');
        this.props.analyzeImage(base64data, this.getSkinToneInt());
        this.setState({ image: base64data, imageBlob: file, cameraOpen: false, cameraError: null });
      },
      {
        canvas: true,
        orientation: true,
      },
    );
  };

  devInput() {
    const { isBackground } = this.props;

    if (!isBackground && (process.env.NODE_ENV === 'development' || getParameterByName('inputFile'))) {
      return (
        <input
          type="file"
          id="fileinput"
          ref={input => {
            this.fileInput = input;
          }}
          style={{
            position: 'absolute',
            top: 30,
            left: 10,
            zIndex: 10,
          }}
          onChange={e => {
            e.preventDefault();
            this.handleImageChange(e);
          }}
        />
      );
    }
  }

  componentWillReceiveProps = props => {
    try {
      if (!this.state.cameraOpen && props.cvResults) {
        this.setState({ cvResults: props.cvResults });
        if (!props.cvResults.error) {
          props.nextPage();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { cameraOpen, image, cameraClass, cameraError, cvResults, showTips } = this.state;
    const { isBackground, t, options } = this.props;

    if (cameraOpen && !cvResults) {
      // initial state: Camera is open, no image taken yet.
      return (
        <div>
          {!isBackground && this.devInput()}
          <StyledSelfieWrapper
            onClick={e => {
              e.preventDefault();
              this.capture();
            }}
          >
            {!isBackground && (
              <div>
                <StyledPulse></StyledPulse>
                <StyledHeading>{t('look_at_the_camera')}</StyledHeading>
                {options && options.instructions && (
                  <StyledInstructions>
                    {options.instructions.map((instruction, i) => {
                      return <StyledInstruction key={'instruction' + i}> {t(instruction)} </StyledInstruction>;
                    })}
                  </StyledInstructions>
                )}
                <div className="guide"></div>
                <ReactCSSTransitionGroup
                  transitionName="footerSlide"
                  transitionAppear={true}
                  transitionEnter={true}
                  transitionLeave={true}
                  transitionAppearTimeout={900}
                  transitionLeaveTimeout={900}
                  transitionEnterTimeout={900}
                >
                  {showTips && (
                    <StyledTips>
                      <div
                        className="closeTips"
                        onClick={e => {
                          e.stopPropagation();
                          this.setState({ showTips: false });
                        }}
                      >
                        X
                      </div>
                      {options && options.tipsTitle && <h1>{t(options.tipsTitle)}</h1>}
                      <ul>
                        {options &&
                          options.tips &&
                          options.tips.map((tip, i) => {
                            return <li key={'tip' + i}>{t(tip)}</li>;
                          })}
                      </ul>
                    </StyledTips>
                  )}
                </ReactCSSTransitionGroup>
                <h4 className="hint">{t('tap_take_picture')}</h4>
                <button
                  className="cancel"
                  onClick={e => {
                    e.preventDefault();
                    this.props.prevPage();
                  }}
                >
                  {t('cancel')}
                </button>
              </div>
            )}
            {!isBackground && cameraClass === 'revieve-camera-loading' ? (
              <Processing label={t('activating_camera')} />
            ) : null}

            <StyledWebcam userAgent={window.navigator.userAgent}>
              <Webcam
                className={cameraClass}
                screenshotFormat="image/jpeg"
                width={1280}
                height={1280}
                ref={webcam => {
                  this.webcam = webcam;
                }}
                audio={false}
                onUserMedia={() => {
                  setTimeout(() => {
                    this.setState({ cameraClass: 'revieve-camera-ready' });
                  }, 2500);
                }}
                onUserMediaError={e => {
                  console.log('camera error');
                  setTimeout(() => {
                    this.setState({ cameraClass: 'revieve-camera-error' });
                  }, 500);

                  setTimeout(() => {
                    this.setState({ cameraError: e, cameraOpen: false });
                  }, 1200);
                }}
              />
            </StyledWebcam>
          </StyledSelfieWrapper>
        </div>
      );
    } else if (image && !cvResults) {
      // User took an image, show it back. Upload and processing progress goes here
      return (
        <StyledSelfieWrapper img={image}>
          <Processing label={t('uploading_selfie')} />
        </StyledSelfieWrapper>
      );
    } else if (cvResults) {
      // Image was processed. Show possible errors and warnings, ask to retry.
      return (
        <StyledSelfieWrapper img={image}>
          {this.devInput()}

          <StyledHeading>{cvResults.message}</StyledHeading>
          <div className="warning">
            <ul>
              {cvResults.status &&
                cvResults.status.map((status, si) => {
                  return <li key={si}>{status.description}</li>;
                })}
            </ul>
            <div className="action">
              <button onClick={this.reset}>{t('retake_selfie')}</button>
              {cvResults.error ? null : <button onClick={this.props.nextPage}>{t('continue')}</button>}
            </div>
          </div>
        </StyledSelfieWrapper>
      );
    } else if (cameraError) {
      // camera error.
      return (
        <StyledSelfieWrapper
          onClick={e => {
            e.preventDefault();
          }}
        >
          {this.devInput()}

          <StyledPulse></StyledPulse>
          <StyledHeading>{t('error_opening_camera')}</StyledHeading>
          <h4 className="hint">{cameraError.message ? cameraError.message : null}</h4>

          <button className="cancel" onClick={this.props.prevPage}>
            {t('back')}
          </button>

          {process.env.NODE_ENV === 'dev' ? (
            <button className="" onClick={this.props.nextPage}>
              Skip (only for devmode)
            </button>
          ) : null}

          <StyledWebcam userAgent={window.navigator.userAgent}>
            <video className={cameraClass} style={{ width: 1280, height: 1280 }} />
          </StyledWebcam>
        </StyledSelfieWrapper>
      );
    }
  }
}

export default translate()(Selfie);



// WEBPACK FOOTER //
// ./src/components/instore/Selfie.js